import React from "react";
import PropTypes from "prop-types";
import {Box} from "@unibuddy/patron";
import styled from "styled-components";
import get from "lodash/get";
import {ResponsiveEmbed} from "../../../../components/ResponsiveEmbed/ResponsiveEmbed";
import BlogImage from "../BlogImage/BlogImage";
import Carousel from "../../../General/components/Carousel/Carousel";

const Image = styled(BlogImage)`
    max-width: 100%;
    object-fit: cover;
    aspect-ratio: ${(props) => (props.aspectRatio ? props.aspectRatio : "4/3")};
    border-radius: ${(props) => (props.borderRadius ? props.borderRadius : 0)};
`;

const BlogPostDetailImageMedia = ({image, title, width, height, ...props}) => {
    if (!width) {
        width = 720;
    }
    return (
        <Box minH={"275px"}>
            {/*Currently we use this component in ContentPreview within prospect chat*/}
            <Image image={image} title={title} width={width} height={height} {...props} />
        </Box>
    );
};

const BlogPostDetailVideoMedia = ({youtubeVideo, title, ...props}) => (
    <ResponsiveEmbed>
        <iframe
            src={`https://www.youtube-nocookie.com/embed/${youtubeVideo}`}
            title={title}
            style={{borderRadius: props.borderRadius}} // Can't give class here
        />
    </ResponsiveEmbed>
);

const BlogPostDetailMedia = ({post, ...props}) => {
    const youtubeVideo = get(post, "youtubeVideo");
    const coverImages = get(post, "coverImages") || [];
    const title = get(post, "title");

    return (
        <>
            {coverImages?.length > 0 && (
                <Carousel autoplay infinite dots={false} arrows={false}>
                    {coverImages.map((image, idx) => (
                        <BlogPostDetailImageMedia
                            // eslint-disable-next-line react/no-array-index-key
                            key={`${post.id}-${idx}`}
                            image={image}
                            title={`${title} (${idx})`}
                            {...props}
                        />
                    ))}
                </Carousel>
            )}
            {youtubeVideo && (
                <BlogPostDetailVideoMedia
                    youtubeVideo={youtubeVideo}
                    title={title}
                    borderRadius={props.borderRadius}
                />
            )}
        </>
    );
};

BlogPostDetailMedia.propTypes = {
    // eslint-disable-next-line react/no-unused-prop-types
    post: PropTypes.object,
};

BlogPostDetailMedia.defaultProps = {
    post: {},
};

export default BlogPostDetailMedia;
